import { getFeedbackProductName, type FeedbackProduct } from '../common/feedbackProduct';

interface ThreadPresentationData {
    type?: number | string;
    title?: string;
    source?: string;
    images?: unknown[];
    video?: { url?: string };
    feedback?: {
        solveState?: number | string;
        product?: FeedbackProduct;
        systemVersion?: string;
    };
}

const feedbackStatuses: Record<string, { text: string; style: string }> = {
    '0': { text: '未解决', style: 'feedbackStatus0' },
    '1': { text: '待处理', style: 'feedbackStatus1' },
    '2': { text: '已回复', style: 'feedbackStatus2' },
    '3': { text: '已解决', style: 'feedbackStatus3' },
};

export const getFeedbackStatus = (solveState?: number | string) => feedbackStatuses[String(solveState)];

export const getThreadPresentation = (threadData: ThreadPresentationData) => {
    const isFeedback = Number(threadData.type) === 2;
    const hasVideo = Boolean(threadData.video?.url);
    const showImages = Number(threadData.type) !== 0 && Boolean(threadData.images?.length) && !(isFeedback && hasVideo);

    return {
        isFeedback,
        hasVideo,
        showImages,
        hideInlineImages: isFeedback && (hasVideo || showImages),
        videoBeforeContent: hasVideo && Number(threadData.type) === 1,
        videoAfterContent: hasVideo && Number(threadData.type) !== 1,
        feedbackProductName: getFeedbackProductName(threadData.feedback?.product),
        feedbackSystemVersion: threadData.feedback?.systemVersion?.trim() || '待补充',
    };
};
